import React, { FC, ReactElement, useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button, Card, Typography, Alert, Row, Col } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { BASE_URL } from "../../constants/urlConstants";
import axios from "axios";

const ROLE_ADMIN    = "1";
const ROLE_ME       = "2";
const ROLE_EMPLOYEE = "4";

const StaffLogin: FC = (): ReactElement => {
  const history  = useHistory();
  const [error,   setError]   = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { mobile: string; password: string }) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.post(
        `${BASE_URL}/api/finalle/employee/login`,
        values
      );

      const { token, role, employeeId, name, mobile } = response.data;

      // ✅ Clear stale data from previous session
      localStorage.clear();

      // ✅ Store all fields
      localStorage.setItem("token",      token                    ?? "");
      localStorage.setItem("role",       role                     ?? "");
      localStorage.setItem("mobile",     mobile ?? values.mobile  ?? "");
      localStorage.setItem("name",       name                     ?? "Staff");
      localStorage.setItem("employeeId", String(employeeId        ?? ""));

      // ✅ Notify NavBar to re-read auth state
      window.dispatchEvent(new Event("storage"));

      // ── Role-based redirect ──
      if (role === ROLE_ADMIN || role === ROLE_EMPLOYEE) {
        history.push("/account/user/info");
      } else if (role === ROLE_ME) {
        history.push("/fin/dashboard");
      } else {
        setError("Unauthorized staff role");
        localStorage.clear();
      }

    } catch (err: any) {
      setError(err.response?.data?.message || "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" align="middle" style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Col xs={22} sm={16} md={12} lg={8}>
        <Card bordered={false} style={{ borderRadius: 12 }}>
          <Typography.Title level={3} style={{ textAlign: "center" }}>
            Staff Login
          </Typography.Title>

          {error && (
            <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />
          )}

          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Mobile Number"
              name="mobile"
              rules={[
                { required: true, message: "Please enter mobile number" },
                { pattern: /^\d{10}$/, message: "Enter a valid 10-digit number" },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                size="large"
                maxLength={10}
                placeholder="10-digit mobile number"
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please enter password" }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                size="large"
                placeholder="Enter your password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                size="large"
                block
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default StaffLogin;